const discovery = {
  namespaced: true,
  state: {
    popularKeywords: [],
    programSearchRecommendation: [],
    institutionSearchRecommendation: [],
    isOpenNavbarRecommendation: false
  },
  mutations: {
    SET_POPULAR_KEYWORD (state, payload) {
      state.popularKeywords = payload
    },
    SET_IS_OPEN_NAVBAR_RECOMMENDATION (state, payload) {
      state.isOpenNavbarRecommendation = payload
    },
    SET_PROGRAM_SEARCH_RECOMMENDATION (state, payload) {
      state.programSearchRecommendation = payload
    },
    SET_INSTITUTION_SEARCH_RECOMMENDATION (state, payload) {
      state.institutionSearchRecommendation = payload
    }
  }
}

export default discovery
